import { c as _c } from "react/compiler-runtime";
import { HotelCardLink, HotelCardLinkProperties, hotelCardOnClick } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { HotelCardThumbnail } from "@website/accommodation-ui/hotel-card-new/hotel-card-thumbnail";
import { HotelCardPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { useViewPort } from "@website/hooks/viewport";
import { addEventToDataLayer } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS, USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { ApplicationNameType, addEventToTracking, mapProductForUserTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import omit from "lodash-es/omit";
import { FC, useEffect, useState } from "react";
import { HotelSnappPayBadge } from "../hotel-snapp-pay";
import { HotelCardAction } from "./hotel-card-action";
import { HotelCardPricing } from "./hotel-card-action/hotel-card-pricing";
import { HotelCardInfo } from "./hotel-card-info";
const appName = process.env.NEXT_PUBLIC_APP_NAME as ApplicationNameType;
export const HotelCardDivider: FC<Pick<HotelCardPropertiesType, "size">> = t0 => {
  const $ = _c(8);
  const {
    size
  } = t0;
  const t1 = `block h-px w-full ${size === "small" ? "" : "lg:hidden"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "repeating-linear-gradient(to right, #EBECF2 0, #EBECF2 4px, transparent 4px, transparent 8px)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <div className={t1} style={t2} />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== size) {
    t4 = size !== "small" && <div className="h-full w-px" style={{
      background: "repeating-linear-gradient(to bottom, #EBECF2 0, #EBECF2 4px, transparent 4px, transparent 8px)"
    }} />;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const HotelCard: FC<HotelCardPropertiesType> = properties => {
  const $ = _c(139);
  const {
    isMobile
  } = useViewPort();
  const [clickLoading, setClickLoading] = useState(0);
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage" || process.env.NEXT_PUBLIC_APP_NAME === "website";
  const {
    className,
    loading,
    hotelInfo,
    size: t0,
    index,
    replace,
    snappPayData,
    isSuggestedCard,
    utm,
    onMouseEnter,
    onMouseLeave,
    onLinkClick,
    targetLink,
    showMap,
    shouldRedirectUsingJs,
    showCarousel: t1,
    isLanding,
    homePageSectionName,
    isHotelDomHomePage,
    isPriorityImage,
    isVillaHomePage: t2,
    noFollow,
    isLastMinute,
    actionButtonText
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const showCarousel = t1 === undefined ? true : t1;
  const isVillaHomePage = t2 === undefined ? false : t2;
  const {
    id,
    hotelDetail,
    hotelOffers,
    thumbnail,
    pricing,
    reservationInfo,
    primaryBadge,
    regularBadges,
    advertisementBadge,
    facilities,
    gallery,
    location,
    categories,
    hasSnappProDiscount,
    transportation,
    isInternational
  } = hotelInfo;
  const router = useCompatRouter();
  const {
    isDesktop
  } = useViewPort();
  const {
    reference,
    inView
  } = useIsVisible();
  let t3;
  if ($[0] !== router) {
    t3 = () => router.replace(router?.pathname, omit(router?.query, "modal"), {
      shallow: true,
      scroll: false
    });
    $[0] = router;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onClose = t3;
  let t4;
  if ($[2] !== hotelInfo.hotelDetail || $[3] !== hotelInfo.id || $[4] !== hotelInfo.pricing || $[5] !== hotelInfo.ruleId || $[6] !== inView || $[7] !== index || $[8] !== router.query) {
    t4 = () => {
      if (!inView) {
        return;
      }
      if (isHomePage) {
        return;
      }
      addEventToDataLayer(DATA_LAYER_EVENTS.VIEW_ITEM_LIST, {
        items: [{
          item_name: hotelInfo?.hotelDetail?.hotelTitle,
          item_id: hotelInfo?.id,
          price: hotelInfo?.pricing?.price,
          item_brand: "IRR",
          item_category: hotelInfo?.hotelDetail?.cityTitle,
          item_category2: hotelInfo?.hotelDetail?.accommodationType,
          item_category3: hotelInfo?.hotelDetail?.stars,
          item_list_name: `هتل های ${hotelInfo?.hotelDetail?.cityTitle}`,
          item_list_id: hotelInfo?.hotelDetail?.cityId,
          index
        }]
      });
      const payload = {
        position: index,
        accommodation_id: hotelInfo.id
      };
      if (["villa", "hotel-domestic", "hotel-international"].includes(appName)) {
        addEventToTracking(USER_TRACKING_EVENTS.HOTEL_CARD_VIEWED, {
          date_from: String(router.query.date_from) || "",
          date_to: String(router.query.date_to) || "",
          city: hotelInfo.hotelDetail?.cityTitle,
          city_id: hotelInfo.hotelDetail?.cityId,
          hotel: hotelInfo.hotelDetail?.hotelTitle,
          hotel_id: hotelInfo.id,
          price: hotelInfo.pricing.price,
          price_off: hotelInfo.pricing.priceOff,
          discount_percent: hotelInfo.pricing.discountPercentage,
          is_available: hotelInfo.hotelDetail.isAvailable,
          price_engine_rules: [{
            id: hotelInfo?.ruleId ?? 0,
            title: ""
          }],
          product: mapProductForUserTracking(appName),
          ...payload
        });
      }
    };
    $[2] = hotelInfo.hotelDetail;
    $[3] = hotelInfo.id;
    $[4] = hotelInfo.pricing;
    $[5] = hotelInfo.ruleId;
    $[6] = inView;
    $[7] = index;
    $[8] = router.query;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hotelInfo || $[11] !== inView || $[12] !== index || $[13] !== router) {
    t5 = [hotelInfo, inView, index, router];
    $[10] = hotelInfo;
    $[11] = inView;
    $[12] = index;
    $[13] = router;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  const t6 = hotelInfo?.hotelDetail?.hotelPageUrl?.href;
  const t7 = hotelInfo?.hotelDetail?.hotelPageUrl?.pathname;
  const t8 = hotelInfo?.hotelDetail?.hotelPageUrl?.query as object;
  let t9;
  if ($[15] !== router.query || $[16] !== t8) {
    t9 = {
      ...router.query,
      ...t8
    };
    $[15] = router.query;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = !isSuggestedCard && replace;
  const t11 = hotelDetail?.hotelTitle;
  let t12;
  if ($[18] !== homePageSectionName || $[19] !== hotelInfo || $[20] !== index || $[21] !== isLastMinute || $[22] !== noFollow || $[23] !== onLinkClick || $[24] !== shouldRedirectUsingJs || $[25] !== t10 || $[26] !== t11 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9 || $[30] !== targetLink || $[31] !== utm) {
    t12 = {
      hotelInfo,
      href: t6,
      pathname: t7,
      query: t9,
      setClickLoading,
      index,
      utm,
      replace: t10,
      target: targetLink,
      title: t11,
      shouldRedirectUsingJs,
      children: "",
      onLinkClick,
      homePageSectionName,
      isHomePage,
      isLastMinute,
      noFollow
    };
    $[18] = homePageSectionName;
    $[19] = hotelInfo;
    $[20] = index;
    $[21] = isLastMinute;
    $[22] = noFollow;
    $[23] = onLinkClick;
    $[24] = shouldRedirectUsingJs;
    $[25] = t10;
    $[26] = t11;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = targetLink;
    $[31] = utm;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const linkProperties = t12;
  const t13 = `bg-on-color-high-emphasis shadow-1 flex flex-col overflow-hidden rounded-2xl p-0 sm:p-3 ${className} ${size === "small" ? `${appName === "villa" ? "" : "cursor-pointer"} h-full gap-3` : "md:flex-row"} ${size === "xSmall" ? "h-[118px] w-[272px] cursor-pointer !flex-row items-center gap-2 !rounded-[8px] !p-2 !shadow-none" : ""}`;
  let t14;
  if ($[33] !== id || $[34] !== onMouseEnter) {
    t14 = () => onMouseEnter?.(Number(id));
    $[33] = id;
    $[34] = onMouseEnter;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== id || $[37] !== onMouseLeave) {
    t15 = () => onMouseLeave?.(Number(id));
    $[36] = id;
    $[37] = onMouseLeave;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== homePageSectionName || $[40] !== hotelInfo || $[41] !== index || $[42] !== isLastMinute || $[43] !== onLinkClick || $[44] !== router || $[45] !== size || $[46] !== utm) {
    t16 = size === "xSmall" || size === "small" && appName !== "villa" ? hotelCardOnClick({
      query: utm,
      router,
      setClickLoading,
      index,
      hotelInfo,
      onLinkClick,
      homePageSectionName,
      isHomePage,
      isLastMinute
    }) : undefined;
    $[39] = homePageSectionName;
    $[40] = hotelInfo;
    $[41] = index;
    $[42] = isLastMinute;
    $[43] = onLinkClick;
    $[44] = router;
    $[45] = size;
    $[46] = utm;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  const t17 = hotelOffers?.specialOffer;
  const t18 = hotelDetail?.stars;
  const t19 = hotelDetail?.hotelTitle;
  let t20;
  if ($[48] !== gallery || $[49] !== id || $[50] !== isPriorityImage || $[51] !== primaryBadge || $[52] !== showCarousel || $[53] !== size || $[54] !== t17 || $[55] !== t18 || $[56] !== t19 || $[57] !== thumbnail) {
    t20 = <HotelCardThumbnail gallery={gallery} id={id} isPriorityImage={isPriorityImage} primaryBadge={primaryBadge} showCarousel={showCarousel} size={size} specialOffer={t17} stars={t18} thumbnail={thumbnail} title={t19} />;
    $[48] = gallery;
    $[49] = id;
    $[50] = isPriorityImage;
    $[51] = primaryBadge;
    $[52] = showCarousel;
    $[53] = size;
    $[54] = t17;
    $[55] = t18;
    $[56] = t19;
    $[57] = thumbnail;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== linkProperties || $[60] !== t20) {
    t21 = <HotelCardLink {...linkProperties} className="md:flex">{t20}</HotelCardLink>;
    $[59] = linkProperties;
    $[60] = t20;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  const t22 = `flex min-w-0 shrink grow flex-col ${size === "xSmall" ? "h-full" : ""}`;
  const t23 = `flex h-full flex-col px-3 ${isLanding || size === "small" ? "!pb-3 sm:!pb-0" : "pb-1"} sm:p-0 md:gap-3 ${size === "xSmall" ? "!gap-1 !px-0" : ""} ${["small", "xSmall"].includes(size) ? "" : "lg:flex-row"}`;
  const t24 = hotelDetail?.isInstant;
  let t25;
  if ($[62] !== hotelOffers?.offers) {
    t25 = hotelOffers?.offers || [];
    $[62] = hotelOffers?.offers;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  const t26 = hotelDetail?.propertyId;
  const t27 = showMap && !isMobile;
  let t28;
  if ($[64] !== advertisementBadge || $[65] !== categories || $[66] !== facilities || $[67] !== hasSnappProDiscount || $[68] !== hotelDetail || $[69] !== id || $[70] !== isHotelDomHomePage || $[71] !== isInternational || $[72] !== isSuggestedCard || $[73] !== linkProperties || $[74] !== loading || $[75] !== location || $[76] !== pricing || $[77] !== regularBadges || $[78] !== reservationInfo || $[79] !== size || $[80] !== snappPayData || $[81] !== t24 || $[82] !== t25 || $[83] !== t26 || $[84] !== t27 || $[85] !== transportation) {
    t28 = <HotelCardInfo {...hotelDetail} isHotelDomHomePage={isHotelDomHomePage} linkProperties={linkProperties} advertisementBadge={advertisementBadge} facilities={facilities} id={id} isInstant={t24} isSuggestedCard={isSuggestedCard} loading={loading} location={location} offers={t25} pricing={pricing} propertyId={t26} regularBadges={regularBadges} reservationInfo={reservationInfo} showMap={t27} size={size} snappPayData={snappPayData} categories={categories} hasSnappProDiscount={hasSnappProDiscount} transportation={transportation} isInternational={isInternational} />;
    $[64] = advertisementBadge;
    $[65] = categories;
    $[66] = facilities;
    $[67] = hasSnappProDiscount;
    $[68] = hotelDetail;
    $[69] = id;
    $[70] = isHotelDomHomePage;
    $[71] = isInternational;
    $[72] = isSuggestedCard;
    $[73] = linkProperties;
    $[74] = loading;
    $[75] = location;
    $[76] = pricing;
    $[77] = regularBadges;
    $[78] = reservationInfo;
    $[79] = size;
    $[80] = snappPayData;
    $[81] = t24;
    $[82] = t25;
    $[83] = t26;
    $[84] = t27;
    $[85] = transportation;
    $[86] = t28;
  } else {
    t28 = $[86];
  }
  let t29;
  if ($[87] !== size) {
    t29 = size !== "xSmall" && <div className="md:ps-4 lg:ps-0"><HotelCardDivider size={size} /></div>;
    $[87] = size;
    $[88] = t29;
  } else {
    t29 = $[88];
  }
  let t30;
  if ($[89] !== actionButtonText || $[90] !== clickLoading || $[91] !== hasSnappProDiscount || $[92] !== hotelDetail?.isAvailable || $[93] !== hotelDetail?.isFomo || $[94] !== hotelDetail?.roomCount || $[95] !== hotelDetail?.roomTitle || $[96] !== id || $[97] !== isHotelDomHomePage || $[98] !== isLanding || $[99] !== isVillaHomePage || $[100] !== linkProperties || $[101] !== loading || $[102] !== pricing || $[103] !== reservationInfo || $[104] !== size) {
    t30 = size === "xSmall" ? <HotelCardPricing {...pricing} size={size} hasSnappProDiscount={hasSnappProDiscount} /> : <HotelCardAction isLanding={isLanding} linkProperties={linkProperties} clickLoading={clickLoading === id} isAvailable={hotelDetail?.isAvailable} isFomo={hotelDetail?.isFomo} loading={loading} pricingInfo={pricing} reservationInfo={reservationInfo} roomCount={hotelDetail?.roomCount} roomTitle={hotelDetail?.roomTitle} size={size} hasSnappProDiscount={hasSnappProDiscount} isHotelDomHomePage={isHotelDomHomePage} isVillaHomePage={isVillaHomePage} actionButtonText={actionButtonText} />;
    $[89] = actionButtonText;
    $[90] = clickLoading;
    $[91] = hasSnappProDiscount;
    $[92] = hotelDetail?.isAvailable;
    $[93] = hotelDetail?.isFomo;
    $[94] = hotelDetail?.roomCount;
    $[95] = hotelDetail?.roomTitle;
    $[96] = id;
    $[97] = isHotelDomHomePage;
    $[98] = isLanding;
    $[99] = isVillaHomePage;
    $[100] = linkProperties;
    $[101] = loading;
    $[102] = pricing;
    $[103] = reservationInfo;
    $[104] = size;
    $[105] = t30;
  } else {
    t30 = $[105];
  }
  let t31;
  if ($[106] !== t23 || $[107] !== t28 || $[108] !== t29 || $[109] !== t30) {
    t31 = <div className={t23}>{t28}{t29}{t30}</div>;
    $[106] = t23;
    $[107] = t28;
    $[108] = t29;
    $[109] = t30;
    $[110] = t31;
  } else {
    t31 = $[110];
  }
  let t32;
  if ($[111] !== t22 || $[112] !== t31) {
    t32 = <div className={t22}>{t31}</div>;
    $[111] = t22;
    $[112] = t31;
    $[113] = t32;
  } else {
    t32 = $[113];
  }
  let t33;
  if ($[114] !== loading || $[115] !== pricing?.price || $[116] !== pricing?.priceOff || $[117] !== size || $[118] !== snappPayData) {
    t33 = size !== "small" && size !== "xSmall" && <div className="mt-2 block md:hidden"><HotelSnappPayBadge {...snappPayData} loading={loading} page="cityPage" price={pricing?.priceOff || pricing?.price} /></div>;
    $[114] = loading;
    $[115] = pricing?.price;
    $[116] = pricing?.priceOff;
    $[117] = size;
    $[118] = snappPayData;
    $[119] = t33;
  } else {
    t33 = $[119];
  }
  let t34;
  if ($[120] !== reference || $[121] !== t13 || $[122] !== t14 || $[123] !== t15 || $[124] !== t16 || $[125] !== t21 || $[126] !== t32 || $[127] !== t33) {
    t34 = <div className={t13} onMouseEnter={t14} onMouseLeave={t15} onClick={t16} ref={reference}>{t21}{t32}{t33}</div>;
    $[120] = reference;
    $[121] = t13;
    $[122] = t14;
    $[123] = t15;
    $[124] = t16;
    $[125] = t21;
    $[126] = t32;
    $[127] = t33;
    $[128] = t34;
  } else {
    t34 = $[128];
  }
  let t35;
  if ($[129] !== id || $[130] !== isDesktop || $[131] !== onClose || $[132] !== primaryBadge?.description || $[133] !== primaryBadge?.text || $[134] !== router.query?.modal) {
    t35 = router?.query?.modal === `badge-info-${id}` && !isDesktop && <div className="block md:hidden"><MiniPopover onClose={onClose} open={router?.query?.modal === `badge-info-${id}`} title={primaryBadge?.text} className="!z-[100]"><div className="flex w-full flex-col gap-4 px-6 pb-6"><span className="text-body-2">{primaryBadge?.description}</span><Button color="secondary" onClick={onClose} text={"\u0645\u062A\u0648\u062C\u0647 \u0634\u062F\u0645"} variant="outline" /></div></MiniPopover></div>;
    $[129] = id;
    $[130] = isDesktop;
    $[131] = onClose;
    $[132] = primaryBadge?.description;
    $[133] = primaryBadge?.text;
    $[134] = router.query?.modal;
    $[135] = t35;
  } else {
    t35 = $[135];
  }
  let t36;
  if ($[136] !== t34 || $[137] !== t35) {
    t36 = <>{t34}{t35}</>;
    $[136] = t34;
    $[137] = t35;
    $[138] = t36;
  } else {
    t36 = $[138];
  }
  return t36;
};